// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-1c362b14] .el-tabs--left {\n  overflow: initial;\n}\n.all-container[data-v-1c362b14] {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n}\n.all-container .body[data-v-1c362b14] {\n  flex: 1;\n}\n.image[data-v-1c362b14] {\n  width: 160px;\n  height: 160px;\n}\n.mt-20[data-v-1c362b14] {\n  margin-top: 20px;\n}\n.mb-10[data-v-1c362b14] {\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
